export default __webpack_public_path__ + "static/media/DLR.3eae612e.jfif";